import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../../assets/promiseFrame/nevsCardLineBlue.png'
import _imports_1 from '../../../../../assets/promiseFrame/nevsCardLineGreen.png'
import _imports_2 from '../../../../../assets/promiseFrame/268Logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-76ad9e06")

_pushScopeId("data-v-76ad9e06")
const _hoisted_1 = { class: "nevsCard" }
const _hoisted_2 = { class: "cardBox" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("车况检测 ")
const _hoisted_4 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("电池检测 ")
const _hoisted_6 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_7 = { class: "cardCont" }
const _hoisted_8 = { class: "cardContItem cardContBlue" }
const _hoisted_9 = { class: "cardLevel" }
const _hoisted_10 = { class: "resbox" }
const _hoisted_11 = { class: "rectangle_resBox" }
const _hoisted_12 = { class: "rectangle_resBox_item" }
const _hoisted_13 = { class: "rectangle_resBox_item_txt" }
const _hoisted_14 = { class: "rectangle_resBox_item" }
const _hoisted_15 = { class: "rectangle_resBox_item_txt" }
const _hoisted_16 = { class: "rectangle_resBox_item" }
const _hoisted_17 = { class: "rectangle_resBox_item_txt" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "nevsCardLine" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_19 = { class: "resultTxt" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "resTag" }, "检测结果", -1)
const _hoisted_21 = {
  key: 1,
  class: "circle"
}
const _hoisted_22 = { class: "circleItemSlot" }
const _hoisted_23 = { class: "errNum" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("/")
const _hoisted_25 = { class: "totalNum" }
const _hoisted_26 = { class: "circleItemTxt" }
const _hoisted_27 = { class: "cardContItem cardContGreen" }
const _hoisted_28 = { class: "cardLevel" }
const _hoisted_29 = { class: "reportLevel" }
const _hoisted_30 = { class: "levelNum" }
const _hoisted_31 = /*#__PURE__*/_createVNode("i", { class: "iconfont icon-yiwen" }, null, -1)
const _hoisted_32 = { class: "resbox" }
const _hoisted_33 = /*#__PURE__*/_createVNode("span", { class: "resTag" }, "检测结果", -1)
const _hoisted_34 = {
  key: 1,
  class: "cardResult"
}
const _hoisted_35 = { class: "cardResTop" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("循环充电次数")
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("预估满电续航")
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "nevsCardLine" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_1 })
], -1)
const _hoisted_41 = { class: "circle" }
const _hoisted_42 = { class: "circleCont" }
const _hoisted_43 = {
  key: 0,
  class: "circleItemSlot normalTxt"
}
const _hoisted_44 = {
  key: 1,
  class: "circleItemSlot"
}
const _hoisted_45 = { class: "errNum" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("/")
const _hoisted_47 = { class: "totalNum" }
const _hoisted_48 = {
  key: 2,
  class: "circleItemSlot"
}
const _hoisted_49 = /*#__PURE__*/_createVNode("span", { class: "totalNum" }, "-", -1)
const _hoisted_50 = { class: "circleItemTxt" }
const _hoisted_51 = { class: "reportMsgCont" }
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "localIcon",
    src: _imports_2
  })
], -1)
const _hoisted_53 = { class: "reportMsg" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { class: "batteryPop" }
const _hoisted_56 = { class: "batteryPopTitle" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" 电池检测评分说明 ")
const _hoisted_58 = /*#__PURE__*/_createStaticVNode("<div class=\"batteryPopCont\" data-v-76ad9e06><div class=\"batteryPopContTitle\" data-v-76ad9e06><i class=\"batteryPopContTitleLine\" data-v-76ad9e06></i><span class=\"batteryPopContTitleTxt\" data-v-76ad9e06>电池评级（S/D）</span></div><div class=\"batteryPopContTxt\" data-v-76ad9e06> S：动力电池不存在电池安全隐患的情况。<br data-v-76ad9e06> D：动力电池存在电池安全隐患的情况。 </div><div class=\"batteryPopContTitle\" data-v-76ad9e06><i class=\"batteryPopContTitleLine\" data-v-76ad9e06></i><span class=\"batteryPopContTitleTxt\" data-v-76ad9e06>电池健康度评级</span></div><div class=\"batteryPopContTxt\" data-v-76ad9e06> SOH（State of Health)：指电池健康状态，以百分比表示。SOH=（动力电池当前最大容量÷动力电池额定容量）*100%。 </div><div class=\"batteryPopTable\" data-v-76ad9e06><div class=\"batteryPopTableTh\" data-v-76ad9e06>268V SOH评级</div><div class=\"batteryPopTableTr\" data-v-76ad9e06><div class=\"batteryPopTableTd col1\" data-v-76ad9e06>优秀</div><div class=\"batteryPopTableTd col2\" data-v-76ad9e06>90%（含）以上</div></div><div class=\"batteryPopTableTr\" data-v-76ad9e06><div class=\"batteryPopTableTd col1\" data-v-76ad9e06>良好</div><div class=\"batteryPopTableTd col2\" data-v-76ad9e06>80（含）-90%</div></div><div class=\"batteryPopTableTr\" data-v-76ad9e06><div class=\"batteryPopTableTd col1\" data-v-76ad9e06>中等</div><div class=\"batteryPopTableTd col2\" data-v-76ad9e06>65（含）-80%</div></div><div class=\"batteryPopTableTr\" data-v-76ad9e06><div class=\"batteryPopTableTd col1\" data-v-76ad9e06>一般</div><div class=\"batteryPopTableTd col2\" data-v-76ad9e06>65%以下</div></div><div class=\"batteryPopTableTend\" data-v-76ad9e06> 注：动力电池SOH实测数值为百分比，动力电池评级展示时只展示百分比前方数值。 </div></div></div>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_circleCom = _resolveComponent("circleCom")
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["cardTab", {'activeGreen': _ctx.state.activeTab === 1,
                'activeBlue': _ctx.state.activeTab === 0
            }]
      }, [
        _createVNode("div", {
          class: ["cardTabItem", {'active': _ctx.state.activeTab === 0}],
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTab(0)))
        }, [
          _createVNode("p", null, [
            _hoisted_3,
            _createVNode("b", null, _toDisplayString(_ctx.getData('rank')), 1)
          ]),
          _hoisted_4
        ], 2),
        _createVNode("div", {
          class: ["cardTabItem", {'active': _ctx.state.activeTab === 1}],
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeTab(1)))
        }, [
          _createVNode("p", null, [
            _hoisted_5,
            _createVNode("b", null, _toDisplayString(_ctx.getData('batteryDetectLevel')) + _toDisplayString(_ctx.getData('batteryDetectLevel') === 'D' ? '' : (_ctx.getData('soh') === '-' ? '' : _ctx.getData('soh'))), 1)
          ]),
          _hoisted_6
        ], 2)
      ], 2),
      _createVNode("div", _hoisted_7, [
        _withDirectives(_createVNode("div", _hoisted_8, [
          (_ctx.getData("rank") !== "D")
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "cardService",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toExplain()))
              }, _toDisplayString(_ctx.getData('serviceOneTitleH5')), 1))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_9, [
            _createVNode("img", {
              class: "levelImg",
              src: require(`../../../../../assets/batteryFrame/nevs_level_${_ctx.getData('rank')}.png`)
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_10, [
              _createVNode("ul", _hoisted_11, [
                _createVNode("li", _hoisted_12, [
                  _createVNode("img", {
                    src: require(`../../../../../assets/promiseFrame/${_ctx.getData('accidentFlag', 'additionUrl')}`),
                    alt: ""
                  }, null, 8, ["src"]),
                  _createVNode("p", _hoisted_13, _toDisplayString(_ctx.getData('accidentFlag')), 1)
                ]),
                _createVNode("li", _hoisted_14, [
                  _createVNode("img", {
                    src: require(`../../../../../assets/promiseFrame/${_ctx.getData('fireFlag', 'additionUrl')}`),
                    alt: ""
                  }, null, 8, ["src"]),
                  _createVNode("p", _hoisted_15, _toDisplayString(_ctx.getData('fireFlag')), 1)
                ]),
                _createVNode("li", _hoisted_16, [
                  _createVNode("img", {
                    src: require(`../../../../../assets/promiseFrame/${_ctx.getData('waterFlag', 'additionUrl')}`),
                    alt: ""
                  }, null, 8, ["src"]),
                  _createVNode("p", _hoisted_17, _toDisplayString(_ctx.getData('waterFlag')), 1)
                ])
              ])
            ])
          ]),
          _hoisted_18,
          _createVNode("div", _hoisted_19, [
            _hoisted_20,
            _createTextVNode(" " + _toDisplayString(_ctx.getData('rankDesc')), 1)
          ]),
          (_ctx.isShowBatteryOtherMsg)
            ? (_openBlock(), _createBlock("div", _hoisted_21, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.blueCircleList, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "circleItem",
                    key: item.name,
                    onClick: ($event: any) => (_ctx.clickTab(item.clickToId))
                  }, [
                    _createVNode(_component_circleCom, {
                      strokeWidth: _ctx.state.blueCircleWidth,
                      currentGradient: _ctx.state.blueCircle,
                      progress: _ctx.setProgress(item),
                      circleId: item.name
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_22, [
                          _createVNode("span", _hoisted_23, _toDisplayString(item.error), 1),
                          _hoisted_24,
                          _createVNode("span", _hoisted_25, _toDisplayString(item.total), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["strokeWidth", "currentGradient", "progress", "circleId"]),
                    _createVNode("div", _hoisted_26, _toDisplayString(item.nameTxt), 1)
                  ], 8, ["onClick"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.state.activeTab === 0]
        ]),
        _withDirectives(_createVNode("div", _hoisted_27, [
          (_ctx.getData('batteryDetectLevel') !== 'D')
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "cardService",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toExplain()))
              }, _toDisplayString(_ctx.getData('serviceTwoTitleH5')), 1))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_28, [
            _createVNode("div", _hoisted_29, [
              _createVNode("h5", {
                class: "levelTxt",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeBatteryPop && _ctx.changeBatteryPop(...args)))
              }, [
                _createVNode("span", _hoisted_30, _toDisplayString(_ctx.getData('batteryDetectLevel')) + _toDisplayString(_ctx.getData('batteryDetectLevel') === 'D' ? '' : (_ctx.getData('soh') === '-' ? '' : _ctx.getData('soh'))), 1),
                _hoisted_31
              ]),
              _createVNode("img", {
                class: "levelImg",
                src: require('../../../../../assets/promiseFrame/batteryCar.png')
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_32, [
              _hoisted_33,
              _createTextVNode(" " + _toDisplayString(_ctx.getData('batteryDetectLevelDesc')), 1)
            ])
          ]),
          (_ctx.isShowBatteryOtherMsg)
            ? (_openBlock(), _createBlock("div", _hoisted_34, [
                _createVNode("div", _hoisted_35, [
                  _createVNode("p", null, [
                    _hoisted_36,
                    _createVNode("b", null, _toDisplayString(_ctx.getData('numberOfCycles')), 1),
                    (_ctx.getData('numberOfCycles') !== '-' )
                      ? (_openBlock(), _createBlock("span", _hoisted_37, "次"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("p", null, [
                    _hoisted_38,
                    _createVNode("b", null, _toDisplayString(_ctx.getData('kmRemain')), 1),
                    (_ctx.getData('kmRemain') !== '-' )
                      ? (_openBlock(), _createBlock("span", _hoisted_39, "Km"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_40,
                _createVNode("div", _hoisted_41, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.greenCircleList, (item) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "circleItem",
                      key: item.name,
                      onClick: ($event: any) => (_ctx.clickTab(item.clickToId))
                    }, [
                      _createVNode("div", _hoisted_42, [
                        _createVNode(_component_circleCom, {
                          strokeWidth: _ctx.state.greenCircleWidth,
                          currentGradient: _ctx.setCircleGradient(item),
                          progress: _ctx.setProgress(item),
                          circleId: item.name
                        }, {
                          default: _withId(() => [
                            (item.type === 'normal')
                              ? (_openBlock(), _createBlock("div", _hoisted_43, _toDisplayString(_ctx.setCircleGradient(item).contTxt), 1))
                              : (item.total)
                                ? (_openBlock(), _createBlock("div", _hoisted_44, [
                                    _createVNode("span", _hoisted_45, _toDisplayString(item.error), 1),
                                    _hoisted_46,
                                    _createVNode("span", _hoisted_47, _toDisplayString(item.total), 1)
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_48, [
                                    _hoisted_49
                                  ]))
                          ]),
                          _: 2
                        }, 1032, ["strokeWidth", "currentGradient", "progress", "circleId"])
                      ]),
                      _createVNode("div", _hoisted_50, _toDisplayString(item.nameTxt), 1)
                    ], 8, ["onClick"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.state.activeTab === 1]
        ])
      ])
    ]),
    _createVNode("div", _hoisted_51, [
      _hoisted_52,
      _createVNode("div", _hoisted_53, [
        _createTextVNode(" NO." + _toDisplayString(_ctx.getData('reportCode')) + " ", 1),
        (_ctx.getData("reportGenDate"))
          ? (_openBlock(), _createBlock("span", _hoisted_54, " | " + _toDisplayString(_ctx.getData('reportGenDate').replace(/-/g,'.')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.state.isShowBatteryPop,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.isShowBatteryPop = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_55, [
          _createVNode("div", _hoisted_56, [
            _hoisted_57,
            _createVNode("i", {
              class: "iconfont icon-guanbi",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.changeBatteryPop && _ctx.changeBatteryPop(...args)))
            })
          ]),
          _hoisted_58
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
})